import {useState, useEffect, useCallback, useRef} from 'react';
import useMakeApiRequest from "sources/http/useMakeApiRequest";
import {escapeRegExp} from 'lodash';
import usePrevious from 'components/helpers/hooks/usePrevious';

export default function useAutocomplete(entity, value, onChange, {multiple}) {
    const [search, setSearch] = useState('');
    const previousSearch = usePrevious(search);
    const [options, setOptions] = useState([]);
    const hasMore = useRef(true);
    const updateOptions = useCallback((result) => {
        setOptions(result.items);
        hasMore.current = result.hasMore;
    }, [options, setOptions]);

    const handleChangeSearch = (e, v) => {
        // To prevent false positives of onInputChange event
        if (!e) return;

        setSearch(v);
    };

    const [request, startRequest] = useMakeApiRequest(
        'get',
        `/autocomplete/${entity}`,
        {
            params: {
                search,
            }
        },
        {onSuccess: updateOptions},
    );

    useEffect(() => {
        const prevSearchIsPartOfNewSearch = search && previousSearch && search.indexOf(previousSearch) === 0;
        if (prevSearchIsPartOfNewSearch && !hasMore.current) {
            setOptions(options.filter(opt => {
                const value = typeof opt === 'string' ? opt : opt.label;
                const regex = new RegExp(escapeRegExp(search), 'i');

                return regex.test(value);
            }));

            return;
        }

        startRequest();
    }, [search]);

    return [
        {
            value: Array.isArray(value)
                ? value.map(v => {
                    return options.find(o => [v.label, v].includes(o) || [v.label, v].includes(o.label))
                        || v
                })
                : value,
            options,
            onChange,
            multiple,
            loading: request.processing,
            inputValue: search,
            onInputChange: handleChangeSearch,
        },
        request
    ];
}



// WEBPACK FOOTER //
// ./src/components/helpers/hooks/useAutocomplete.js